import {createUseStyles} from 'react-jss';

export default createUseStyles({
  statisticContainer: {
    width: '90%',
    display: 'flex',
    listStyle: 'none',
    margin: 0,
    justifyContent: 'space-between',
  },
  statistic: {
    border: props => `1px solid ${props.theme.completePage.socialSharingStatisticBorderColour}`,
    width: '48%',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
  },
  key: {
    alignItems: 'center',
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
    padding: [5, 7],
  },
  value: {
    backgroundColor: '#f3f3f3',
    textAlign: 'center',
    width: '100%',
    paddingTop: 10,
    paddingBottom: 10,
  },
  explanation: {
    marginTop: '1.5em',
    marginBottom: '1em',
  },
});
